import { multipart } from '@villus/multipart'
import { defaultPlugins, definePlugin, useClient } from 'villus'

import type { App } from 'vue'

const authPlugin = definePlugin(({ opContext }) => {
  const headers = new Headers({
    'content-type': 'application/json',
  })
  opContext.credentials = 'include'
  if (
    import.meta.env.VITE_REVOLUGO_X_CONSUMER_CUSTOM_ID &&
    import.meta.env.VITE_REVOLUGO_X_CONSUMER_GROUPS
  ) {
    headers.append(
      'x-consumer-custom-id',
      import.meta.env.VITE_REVOLUGO_X_CONSUMER_CUSTOM_ID,
    )
    headers.append(
      'x-consumer-groups',
      import.meta.env.VITE_REVOLUGO_X_CONSUMER_GROUPS,
    )
  }

  opContext.headers = Object.fromEntries(headers.entries())
})

export function configureGraphQLClient(app: App) {
  const client = useClient({
    url: `${import.meta.env.VITE_REVOLUGO_GRAPHQL_API_URL}/private`,
    use: [authPlugin, multipart(), ...defaultPlugins()],
  })

  app.use(client)
}
